
import { DocumentIcon, PhotoIcon } from '@heroicons/react/24/outline';

import { Icon } from '@/components/core/Icon';

import { ReactComponent as HeroFileCode } from '../../assets/icons/document-code.svg';
import { ReactComponent as HeroFileWord } from '../../assets/icons/document-doc.svg';
import { ReactComponent as HeroFileJson } from '../../assets/icons/document-json.svg';
import { ReactComponent as HeroFilePdf } from '../../assets/icons/document-pdf.svg';
import { ReactComponent as HeroFilePpt} from '../../assets/icons/document-ppt.svg';
import { ReactComponent as HeroFileText } from '../../assets/icons/document-txt.svg';
import { ReactComponent as HeroFileExcel } from '../../assets/icons/document-xls.svg';
import { ReactComponent as HeroFileArchive } from '../../assets/icons/document-zip.svg';

interface FileTypeIconProps {
  fileType: string;
}

const JsonIcon = ({fileType}: {fileType: string}) => (
    <div className="tw-relative tw-inline-block">
        <Icon icon={DocumentIcon} size="xl" variant='secondary' />
        <span className="tw-absolute
            tw-top-[60%]
            tw-left-1/2
            tw-transform
            tw--translate-x-1/2
            tw--translate-y-1/3
            tw-text-lg
            tw-font-mono
            tw-text-white
            tw-text-[8px]">
            {fileType}
        </span>
    </div>
);

const FileTypeIcon = ({ fileType }: FileTypeIconProps) => {
    const variant='secondary';
    const size = 'tw-h-7 tw-w-7';
    if (fileType) {
        switch (fileType.toLowerCase()) {
            case 'image':
                return <Icon colorScheme='normal' icon={PhotoIcon} size='xl'  variant='secondary'/>;
            case 'code':
            case 'xml':
                return <HeroFileCode className={`icon-variant-${variant} ${size}`}/>;
            case 'json':
                return <HeroFileJson className={`icon-variant-${variant} ${size}`}/>;
            case 'excel':
                return <HeroFileExcel className={`icon-variant-${variant} ${size}`}/>;
            case 'word':
                return <HeroFileWord className={`icon-variant-${variant} ${size}`}/>;
            case 'powerpoint':
                return <HeroFilePpt className={`icon-variant-${variant} ${size}`}/>;
            case 'pdf':
                return <HeroFilePdf className={`icon-variant-${variant} ${size}`} data-testid="file-pdf"/>;
            case 'zip':
                return <HeroFileArchive className={`icon-variant-${variant} ${size}`}/>;
            case 'text':
                return <HeroFileText className={`icon-variant-${variant} ${size}`}/>;
            default:
                return <JsonIcon fileType= {fileType.substring(0, 3)}/>;
        }
    }

};

export default FileTypeIcon;
